module.exports = require('./helpers/bundle-url').getBundleURL('jHzFK') + "deployments-logo.7cb8b9ef.png";